import {
  Component,
  ViewEncapsulation,
  forwardRef,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NotificationModalComponent } from '../../notification-modal.component';
import { PrepaidRedemptionComponent } from '../prepaid-redemption/prepaid-redemption.component';
import { OrderRequestPackagesBlockComponent } from '../order-request-packages-block/order-request-packages-block.component';
import { OrderRequestPrepaidCardsComponent } from '../order-request-prepaid-cards/order-request-prepaid-cards.component';

/**
 * Fleet vehicle found — services selection UI. Logic stays on the parent modal.
 */
@Component({
  selector: 'app-notification-fleet-vehicle-found-layout',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    PrepaidRedemptionComponent,
    OrderRequestPackagesBlockComponent,
    OrderRequestPrepaidCardsComponent,
  ],
  templateUrl: './fleet-vehicle-found-layout.component.html',
  styleUrls: ['../../notification-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class NotificationFleetVehicleFoundLayoutComponent {
  readonly host = inject(
    forwardRef(() => NotificationModalComponent),
    { host: true }
  );
}
